import { render, staticRenderFns } from "./UserHeading.vue?vue&type=template&id=4189d60a&scoped=true&"
import script from "./UserHeading.vue?vue&type=script&lang=js&"
export * from "./UserHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4189d60a",
  null
  
)

export default component.exports